import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material";

const LeavesRequestsFilter = ({ defaultValues, leaveId, setLeaveId }) => {

  const handleChange = (e) => setLeaveId(e.target.value);

  return (
    <>

      <Typography
        variant="h5"
        color="primary"
        sx={{ textAlign: "flex-start" }}
      >
        Заявка за отсъствие
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }} xs={12}>

        <Typography
          mt={2}
          variant="string"
          sx={{ textAlign: "flex-start" }}
        >
          Избери отсъствие
        </Typography>

        <Grid
          container
          spacing={0}
        >
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
          >
            <TextField
              select
              fullWidth
              label={"Отсъствие"}
              onChange={handleChange}
              value={leaveId}
            >
              <MenuItem value="">---------------</MenuItem>
              {defaultValues.map(value => (
                <MenuItem
                  key={value.id}
                  value={value.id}
                >
                  {value.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Box >
    </>
  );
};

export default LeavesRequestsFilter;